module.exports = __webpack_public_path__ + "img/submit.20107e37.png";